import {useTranslation} from "react-i18next";
import "./LocaleSwitcher.css";

import {useEffect, useRef, useState} from "react";
import {supportedLngs} from "./config";

export default function LocaleSwitcher() {
    const {i18n} = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const selectLanguage = (lang) => {
        i18n.changeLanguage(lang).then(() => setIsOpen(false));
    };
    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const dropdownRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    return (
        <div className="language-switcher" ref={dropdownRef}>
            <button className="dropdown-toggle" onClick={toggleDropdown}>
                <span className="current-language">{supportedLngs[i18n.resolvedLanguage]}</span>
                <span className={`arrow ${isOpen ? "open" : "close"}`}>▼</span>
            </button>
            {isOpen && (
                <ul className="dropdown-menu">
                    {Object.entries(supportedLngs).map(([code, name]) => (
                        <li key={code} onClick={() => selectLanguage(code)}>
                            {name}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}